import { UserLoginEntitie } from "@/entities/userLoginEntitie";
import { UserPlanetEntitie } from "@/entities/userPlanetEntitie";
import { userLoginDataStorage } from "@/storages/userLoginDataStorage";
import { userPlanetDataStorage } from "@/storages/userPlanetDataStorage";

class GlobalEvent
{
    app = null;

    constructor(app)
    {
        this.app = app;
    }

    async updateUserPlanetResourceView(planetId)
    {
        const userPlanetDataStorageInstance = userPlanetDataStorage();

        try {
            const response = await this.app.config.globalProperties.$axios.getPlanetResources(planetId);

            console.log("Response data:", response.data);
            console.log("Response code:", response.status);
            console.log("Response headers:", response.headers);

            userPlanetDataStorageInstance.upsertPlanet(
                UserPlanetEntitie.fromJSON(response.data)
            );
        } catch (error) {
            console.error("Error fetching planet resources:", error);
        }
    }

    async refreshAuthToken() {
        const userLoginDataStorageInstance = userLoginDataStorage();

        try {
            const response = await this.app.config.globalProperties.$axios.refreshToken();
            console.log("Refresh token success:", response.data);

            userLoginDataStorageInstance.setUserLoginData(
                UserLoginEntitie.fromJSON(response.data)
            );
        } catch (error) {
            console.error("Refresh token error:", error);
        }
    }
}

export default {
    install(app) {
        app.config.globalProperties.$globalEvent = new GlobalEvent(app);
    }
};